<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="name-type-tab">
	<br/>
	<br/>
	<div class="row pb-3">
        <div class="col d-flex justify-content-end">
            <button class="btn btn-outline-info" [routerLink]="['/', { outlets: { popup: 'name-type-edit-dialog' } }]" queryParamsHandling="merge"
                    data-test="newNameTypeButton">
                <i class="fa fa-asterisk fa-md" aria-hidden="true"></i> {{"new" | translate}}</button>
        </div>
	</div>
	<div class="table-responsive" *ngIf="nameTypes">
		<table class="table table-striped table-bordered table-curved">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
				<th><span jhiSortBy="{{ColumnLabels.CODE}}"><span jhiTranslate="crop-settings-manager.name-type.columns.code"></span><span class="fa fa-sort"></span></span>
					<jhi-column-filter-inline [filter]="filters.code"
											  (onApply)="applyFilters()"
											  (onReset)="resetFilters()"></jhi-column-filter-inline>
				</th>
				<th><span jhiSortBy="{{ColumnLabels.NAME}}"><span jhiTranslate="crop-settings-manager.name-type.columns.name"></span><span class="fa fa-sort"></span></span>
					<jhi-column-filter-inline [filter]="filters.name"
											  (onApply)="applyFilters()"
											  (onReset)="resetFilters()"></jhi-column-filter-inline>
				</th>
				<th><span jhiSortBy="{{ColumnLabels.DESCRIPTION}}"><span jhiTranslate="crop-settings-manager.name-type.columns.description"></span><span class="fa fa-sort"></span></span>
					<jhi-column-filter-inline [filter]="filters.description"
											  (onApply)="applyFilters()"
											  (onReset)="resetFilters()"></jhi-column-filter-inline>
				</th>
				<th style="width: 90px;"><span jhiSortBy="{{ColumnLabels.DATE}}"><span jhiTranslate="crop-settings-manager.name-type.columns.date"></span><span class="fa fa-sort"></span></span>
					<jhi-column-filter-inline [filter]="filters.date"
											  (onApply)="applyFilters()"
											  (onReset)="resetFilters()"></jhi-column-filter-inline>
				</th>
				<th style="width: 95px;"><span jhiTranslate="crop-settings-manager.name-type.columns.action"></span></th>
			</tr>
			</thead>
			<tbody *ngIf="nameTypes.length else nodata">
			<tr *ngFor="let nameType of nameTypes">
				<td>{{nameType.code}}</td>
				<td>{{nameType.name}}</td>
				<td><span class="d-inline-block text-truncate" style="max-width: 800px;" title="{{nameType.description}}">{{nameType.description}}</span></td>
				<td>{{nameType.date}}</td>
				<td class="text-center">
					<button class="btn btn-sm btn-outline-info me-2" (click)="editNameType(nameType)">
						<i class="fa fa-edit fa-md" aria-hidden="true"></i>
					</button>
					<button class="btn btn-sm btn-outline-info me-2" (click)="deleteNameType(nameType)">
						<i class="fa fa-trash fa-md" aria-hidden="true"></i>
					</button>
				</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<tbody>
			<tr>
				<td colspan="5" jhiTranslate="no.data"></td>
			</tr>
			</tbody>
		</ng-template>
	</div>
	<div *ngIf="nameTypes && nameTypes.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
